/**
 * Backend ids are opaque base64 cursors that may contain `+/=` — every id
 * placed in a URL path segment must go through gidPath().
 */
export const gidPath = (id: string) => encodeURIComponent(id);

/**
 * Decodes the numeric `id` out of an opaque GID cursor (`base64(JSON)`).
 * Data-store record/column URLs are the one place that needs this: unlike
 * every other resource, `.../records/:recordId` takes the raw physical row
 * id (`ParseIntPipe`), not the GID itself — the GID (`base64({dataStoreId,
 * id})`) is only what the response body's `record.id` contains.
 */
export const gidId = (gid: string): number => JSON.parse(atob(gid)).id;
